import { render, staticRenderFns } from "./enfantsParent.vue?vue&type=template&id=6e0cec2e&"
import script from "./enfantsParent.vue?vue&type=script&lang=js&"
export * from "./enfantsParent.vue?vue&type=script&lang=js&"
import style0 from "./enfantsParent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports